import type { ButtonHTMLAttributes } from "react";

type Tone = "default" | "ghost";

interface RoundButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: Tone;
}

const BASE =
  "w-9.5 h-9.5 rounded-full grid place-items-center cursor-pointer shrink-0 transition-all duration-150";

const TONE: Record<Tone, string> = {
  default: "border border-line bg-paper text-ink hover:bg-cream-2",
  ghost:
    "text-white border border-white/40 bg-white/25 backdrop-blur-[8px] hover:bg-white/40",
};

export function RoundButton({
  tone = "default",
  className,
  ...rest
}: RoundButtonProps) {
  const classes = `${BASE} ${TONE[tone]}${className ? ` ${className}` : ""}`;
  return <button className={classes} {...rest} />;
}
